import { useState, useEffect } from 'react';
import type { RefObject } from 'react';

import { calculateColumnCount } from 'containers/user/home/components/masonry-grid/masonry-grid.helper';

export const useResponsiveColumns = (
  gridRef: RefObject<HTMLElement | null>,
  columnWidth: number,
  maxColumns: number,
): number => {
  const [columnCount, setColumnCount] = useState<number>(maxColumns);

  useEffect(() => {
    const updateColumnCount = (width: number): void => {
      setColumnCount(calculateColumnCount(width, columnWidth, maxColumns));
    };

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries.length) {
        const { width } = entries[0].contentRect;

        updateColumnCount(width);
      }
    });

    if (gridRef.current) resizeObserver.observe(gridRef.current);

    return () => resizeObserver.disconnect();
  }, [gridRef, columnWidth, maxColumns]);

  return columnCount;
};
